import { render, staticRenderFns } from "./userPays.vue?vue&type=template&id=13100bd6&"
import script from "./userPays.vue?vue&type=script&lang=js&"
export * from "./userPays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports